import { onAuthStateChanged } from "firebase/auth";

import { auth } from "@/firebase";
import { markClientReady } from "@/services/client";
import { useAuthStore } from "@/stores/auth.store";
import { useUserStore } from "@/stores/user.store";

let cachedToken: string | null = null;

export const getCachedToken = async (forceRefresh = false): Promise<string | null> => {
	const user = auth.currentUser;
	if (!user) return null;
	if (forceRefresh) {
		cachedToken = await user.getIdToken(true);
	}
	return cachedToken ?? user.getIdToken();
};

let initialized = false;

export function initializeAuth(): void {
	if (initialized) return;
	initialized = true;

	onAuthStateChanged(
		auth,
		async (user) => {
			const authStore = useAuthStore();
			const userStore = useUserStore();

			if (user) {
				authStore.resetAuthReady();
				cachedToken = await user.getIdToken();
				authStore.setUser(user);
				markClientReady();
			} else {
				cachedToken = null;
				authStore.clearUser();
				userStore.clearUserData();
				markClientReady();
			}

			authStore.markAuthReady();
		},
		(error) => {
			console.error("Auth state error:", error);
		},
	);
}
